<template>
  <div
    class="policy-burmaswift"
    id="policy"
    :style="showPrivasi ? 'height:auto;' : ''"
  >
    <p class="seemore" @click="showPrivasi = true" v-if="!showPrivasi"></p>
    <h2 class="title">ကိုယ်ရေးအချက်အလက်မူဝါဒ</h2>
    <div class="msgs">
      <div class="msg">
        <p>
          အင်္ဂလိပ်လိုင်းလိုင်းကို CHENG Kin Fung မှတီထွင်သည်။
          <br />
          ကျွန်ုပ်တို့၏အပလီကေးရှင်းကိုအသုံးပြုရန်ရွေးချယ်သည့်အတွက်ကျေးဇူးတင်ပါသည်၊
          အင်္ဂလိပ်လိုင်း (ယခုနောက်ပိုင်းတွင် "ကျွန်ုပ်တို့" ဟုရည်ညွှန်းသည်)
          <br />
          သည်သင်၏ကိုယ်ရေးကိုယ်တာကိုယ်ရေးကိုယ်တာနှင့်ဒေတာလုံခြုံရေးကိုကာကွယ်ရန်အလွန်အရေးကြီးပြီးဘေးကင်းပြီးယုံကြည်စိတ်ချရသောဝန်ဆောင်မှုများကိုပေးဆောင်ရန်သင့်အားသန္နိဋ္ဌာန်ချထားပါသည်။
          ကျွန်ုပ်တို့၏အပလီကေးရှင်းကို သင်စတင်အသုံးမပြုမီ၊
          သင့်ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို မည်သို့စုဆောင်းမည်၊ အသုံးပြုမည်၊
          သိမ်းဆည်းမည်၊ ကာကွယ်ရန်နှင့် လုပ်ဆောင်မည်ကို နားလည်ရန်
          ဤကိုယ်ရေးကိုယ်တာမူဝါဒကို အသေးစိတ်ဖတ်ရှုနားလည်ရန် အကြံပြုအပ်ပါသည်။
          ဤကိုယ်ရေးကိုယ်တာမူဝါဒသည် ကျွန်ုပ်တို့စုဆောင်းသည့်
          ကိုယ်ရေးကိုယ်တာအချက်အလက်အမျိုးအစားများ၊ အဘယ်ကြောင့်စုဆောင်းရကြောင်း၊
          ၎င်းကိုအသုံးပြုပုံ၊ မျှဝေပုံနှင့် သင်၏ဆက်စပ်အခွင့်အရေးများနှင့်
          ရွေးချယ်မှုများအပါအဝင် ကျွန်ုပ်တို့၏ ဒေတာလုပ်ဆောင်ခြင်းဆိုင်ရာ
          အလေ့အကျင့်များနှင့် အခြေခံမူများကို သင့်အား အသိပေးရန် ရည်ရွယ်ပါသည်။
          <br />
          ကျွန်ုပ်တို့၏ထုတ်ကုန်များကိုအသုံးပြုသည့်အခါ
          ပိုမိုကောင်းမွန်သောဝန်ဆောင်မှုများကို
          သုံးစွဲသူများခံစားနိုင်စေရန်အတွက် အသုံးပြုသူများသည်
          အင်္ဂလိပ်လိုင်းချေးငွေဝန်ဆောင်မှုများကိုရွေးချယ်သည့်အခါ
          သက်ဆိုင်ရာအချက်အလက်အချို့ကို စုဆောင်းရန်လိုအပ်ပါသည်။ ပစ်မှတ်ထားသော
          ဝန်ဆောင်မှုများကို ပေးဆောင်ရန်အတွက် အသုံးပြုသူ၏ ခရက်ဒစ် အခြေအနေကို
          ပိုမိုကောင်းမွန်စွာ အကဲဖြတ်ရန် ဤအချက်အလက်ကို အသုံးပြုပါသည်။
          အကြွေးအကဲဖြတ်ခြင်းအောင်မြင်ပြီးသော အသုံးပြုသူများသည်
          ချေးငွေလျှောက်ထားနိုင်ပါသည်။ အသုံးပြုသူ၏ခွင့်ပြုချက်မရှိဘဲ၊
          ကျွန်ုပ်တို့သည် သုံးစွဲသူ၏ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို
          မည်သူတစ်ဦးတစ်ယောက်ကိုမျှ ပေးဆောင်ပြီးထုတ်ဖော်မည်မဟုတ်ကြောင်း စိတ်ချပါ။
        </p>
      </div>
      <div class="msg">
        <h4>
          စုဆောင်းရရှိထားသော အချက်အလက်များတွင် အောက်ပါအချက်များ ပါဝင်သည်-
        </h4>
        <p>
          1.ပုံအချက်အလက်- အသုံးပြုသူအထောက်အထား
          စစ်မှန်ကြောင်းအထောက်အထားစိစစ်ခြင်းလုပ်ငန်းစဉ်အတွင်း၊
          လိမ်လည်မှုကာကွယ်ရန်နှင့် အကောင့်လုံခြုံရေးအတွက်၊
          ၎င်းတို့၏အထောက်အထားကိုအတည်ပြုရန်အတွက်
          အသုံးပြုသူမှရွေးချယ်ထားသောပုံများကိုသာ စုဆောင်းပြီး
          အပ်လုဒ်လုပ်ထားသောပုံများကို စုဆောင်းပါမည်။ (ကျွန်ုပ်တို့သည်
          ဝင်ရောက်ကြည့်ရှုခြင်း သို့မဟုတ် ရယူခြင်းမပြုနိုင်သည်ကို သတိပြုပါ။
          ဤနည်းလမ်းဖြင့် သင့်ဓာတ်ပုံအယ်လ်ဘမ်)။ ရွေးချယ်ထားသော ပုံဒေတာအားလုံးကို
          လုံခြုံသောချိတ်ဆက်မှုမှတစ်ဆင့် https://runa.runaway1quickget.com/ သို့
          ပို့လွှတ်မည်ဖြစ်သည်။
          <br />
          2.ခေါ်ဆိုမှုမှတ်တမ်းအချက်အလက််- အင်္ဂလိပ်လိုင်းသို့ မှတ်ပုံတင်ရန်
          သို့မဟုတ် လော့ဂ်အင်လုပ်ရန် အသံအတည်ပြုကုဒ်ကို အသုံးပြုသောအခါတွင်၊
          အင်္ဂလိပ်လိုင်းသည် အသုံးပြုသူ၏ ခေါ်ဆိုမှုမှတ်တမ်း အချက်အလက်ကို ရယူရန်
          လိုအပ်သည် (ခေါ်ဆိုမှုကြာချိန်၊ ခေါ်ဆိုမှုအမျိုးအစား၊ စသည်ဖြင့်)
          ၏အထောက်အထားကို အတည်ပြုရန်အတွက် အသုံးပြုသည်။ အသုံးပြုသူအနေနှင့်
          လုပ်ဆောင်ချက်ကို အသုံးပြုသူကိုယ်တိုင် လုပ်ဆောင်ကြောင်း အတည်ပြုပါသည်။
          ဤအချက်အလက်ကို https://runa.runaway1quickget.com/ သို့
          အပ်လုဒ်လုပ်ပါမည်။ စုဆောင်းထားသော အချက်အလက်များကို
          ပြင်ပအဖွဲ့အစည်းများအား ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          3. ဆက်သွယ်ရန်စာရင်းအချက်အလက်- အင်္ဂလိပ်လိုင်းကိုအသုံးပြု၍
          ချေးငွေလျှောက်ထားသည့်အခါတွင် အင်္ဂလိပ်လိုင်းသည် အဆက်အသွယ်စာရင်း
          (အဆက်အသွယ်အမည်၊ ဆက်သွယ်ရန်အချက်အလက်နှင့် ဆက်ဆံရေးအပါအဝင်)
          အရေးပေါ်အဆက်အသွယ်အဖြစ် ငွေချေးသူ၏အထောက်အထားကို အတည်ပြုရန်နှင့်
          ချေးငွေလုပ်ဆောင်ရန် အရေးပေါ်အဆက်အသွယ်အဖြစ် ရွေးချယ်ရန် လိုအပ်သည်။
          ပိုင်းခြားစိတ်ဖြာချက်၊ ဤအချက်အလက်ကို
          https://runa.runaway1quickget.com/ သို့ အပ်လုဒ်လုပ်ပါမည်။
          စုဆောင်းထားသော အချက်အလက်များကို ပြင်ပအဖွဲ့အစည်းများအား
          ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          4.SMS အချက်အလက်- ချေးငွေလျှောက်ထားရန် အင်္ဂလိပ်လိုင်းကို
          အသုံးပြုသည့်အခါ လိမ်လည်မှုနှင့် ဖြစ်နိုင်ခြေအန္တရာယ်များကို
          ကာကွယ်ရန်အတွက် အင်္ဂလိပ်လိုင်းသည် သင်၏ SMS အချက်အလက် (SMS နံပါတ်၊ SMS
          ခေါင်းစဉ်၊ စသည်) ကို ဝင်ရောက်သုံးစွဲပါမည်။ ဤအချက်အလက်ကို
          https://runa.runaway1quickget.com/ သို့ အပ်လုဒ်လုပ်ပါမည်။
          စုဆောင်းထားသော အချက်အလက်များကို ပြင်ပအဖွဲ့အစည်းများအား
          ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          5. ကိုယ်ရေးကိုယ်တာအချက်အလက်- အင်္ဂလိပ်လိုင္းဖြင့်
          ချေးငွေလျှောက်ထားသည့်အခါ၊ ဂလိပ်လိုင္းသည် သင်၏အမည်၊ ID နံပါတ်နှင့်
          သက်သေခံအချက်အလက်အတွက် မိုဘိုင်းလ်ဖုန်းနံပါတ်တို့အပါအဝင်
          သင်၏ကိုယ်ရေးကိုယ်တာအချက်အလက်ကို ဖြည့်စွက်ရန် လိုအပ်ပါသည်။
          စုဆောင်းထားသော အချက်အလက်များကို ပြင်ပအဖွဲ့အစည်းများအား
          ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          6.တည်နေရာအချက်အလက်- GPS သြဒိနိတ်များနှင့် IP လိပ်စာအပေါ်အခြေခံ၍
          သင်၏အနီးစပ်ဆုံးတည်နေရာဒေတာကို စုဆောင်းပြီး တည်နေရာအချက်အလက်ပေါ်အခြေခံ၍
          သင့်အား ထုတ်ကုန်များကို အကြံပြုရန်အတွက် ၎င်းကိုအသုံးပြုပါမည်။
          အသုံးပြုသူများသည် ကျွန်ုပ်တို့၏ဝန်ဆောင်မှုကိုအသုံးပြုသည့်အခါတွင်သာ
          တည်နေရာအချက်အလက်ကို ရရှိမည်ဖြစ်ကြောင်း ကျေးဇူးပြု၍ ကျေးဇူးပြု၍
          သတိပြုပါ။ စုဆောင်းထားသော အချက်အလက်များကို ပြင်ပအဖွဲ့အစည်းများအား
          ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          7. စက်ပစ္စည်းအချက်အလက်- ကျွန်ုပ်တို့သည် သင်၏ IP လိပ်စာ သို့မဟုတ်
          အခြားထူးခြားသောသတ်မှတ်သူ သို့မဟုတ် အချက်အလက်များကို အကန့်အသတ်မရှိ
          အပါအဝင် သင်အသုံးပြုသည့် ဝန်ဆောင်မှုကို အသုံးပြုသည့် ကွန်ပျူတာ
          သို့မဟုတ် စက်ပစ္စည်း၏ စက်ပစ္စည်းအချက်အလက်ကို စုဆောင်းပါမည်။
          ဤအချက်အလက်တွင် သင်အသုံးပြုနေသည့် ဘရောက်ဆာအမျိုးအစား၊
          စက်ပစ္စည်းအမျိုးအစား၊ လည်ပတ်မှုစနစ်၊ ဆော့ဖ်ဝဲဗားရှင်း၊ ဟာ့ဒ်ဝဲမော်ဒယ်၊
          မိုဘိုင်းကွန်ရက်အချက်အလက်နှင့် ဝန်ဆောင်မှုများကို သင်အသုံးပြုနေသည့်
          ဒိုမိန်းအမည်တို့ ပါဝင်နိုင်သည်။ စုဆောင်းထားသော အချက်အလက်များကို
          ပြင်ပအဖွဲ့အစည်းများအား ထုတ်ဖော်မည်မဟုတ်ပါ။
          <br />
          8. ထည့်သွင်းထားသော အပလီကေးရှင်းများစာရင်း- တရားမဝင် ဖြစ်နိုင်ချေရှိသော
          အပလီကေးရှင်းများကို ခွဲခြားသတ်မှတ်နိုင်ရန်၊ ကျွန်ုပ်တို့သည်
          သင့်စက်ပစ္စည်းပေါ်တွင် ထည့်သွင်းထားသည့် အပလီကေးရှင်းများစာရင်းကို
          စုဆောင်းရန် လိုအပ်ပါသည်။ ဤနည်းဖြင့် ကျွန်ုပ်တို့သည်
          လျှောက်လွှာ၏တရားဝင်မှုကို စစ်ဆေးပြီး သေချာစေနိုင်သည်။
          <br />
          9.Camera အချက်အလက်- သင့်အထောက်အထားကို အတည်ပြုပြီး
          ချေးငွေလုပ်ငန်းစဉ်ကို အရှိန်မြှင့်ရန်အတွက်၊ သင့်ကင်မရာကို
          ဝင်ရောက်ကြည့်ရှုရန်နှင့် ဓာတ်ပုံ/ဗီဒီယိုများရိုက်ရန်အတွက်
          ကျွန်ုပ်တို့အား သင့်အား ခွင့်ပြုပေးရန် လိုအပ်ပါသည်။ ၎င်းက
          ကျွန်ုပ်တို့အား မည်သူမည်ဝါဖြစ်ကြောင်း အတည်ပြုရန်နှင့် ပိုမိုထိရောက်သော
          ချေးငွေဝန်ဆောင်မှုကို ပံ့ပိုးပေးပါသည်။
          <br />
          10. ငွေကြေးဆိုင်ရာ အချက်အလက်- ချေးငွေလုပ်ငန်းစဉ်ကို
          ပြီးမြောက်စေရန်အတွက်၊ သင်သည် သင်၏ချေးငွေကို ဘဏ်အကောင့် သို့မဟုတ်
          အခြားဆက်စပ်အကောင့်များနှင့် ချိတ်ဆက်ရန် လိုအပ်ပါက၊ သင်သည်
          ကျွန်ုပ်တို့အား သင်၏ဘဏ်စာရင်းအချက်အလက် သို့မဟုတ်
          အခြားဆက်စပ်ငွေပေးချေမှုမီဒီယာကို ပေးဆောင်ရန် လိုအပ်ပါသည်။ ၎င်းသည်
          ရန်ပုံငွေများ လုံခြုံစွာ စီးဆင်းမှုနှင့် ချေးငွေလုပ်ငန်းကို
          ချောမွေ့စွာ လုပ်ဆောင်နိုင်စေရန် သေချာစေနိုင်သည်။
          <br />
          11.လူမှုရေးအကောင့်အချက်အလက်- အန္တရာယ်အကဲဖြတ်မှုအတွက်၊ ကျွန်ုပ်တို့သည်
          သင်၏လူမှုရေးအကောင့်အချက်အလက်ကို စုဆောင်းနိုင်ပါသည်။ ဖြစ်နိုင်ချေရှိသော
          အန္တရာယ်များကို အကဲဖြတ်ကာ ပိုမိုဘေးကင်းသော ဝန်ဆောင်မှုများကို
          ပံ့ပိုးပေးနိုင်ရန် ဤအချက်အလက်များကို
          https://runa.runaway1quickget.com/ သို့ အပ်လုဒ်လုပ်ပါမည်။
          စုဆောင်းထားသော အချက်အလက်များကို ပြင်ပအဖွဲ့အစည်းများအား
          ထုတ်ဖော်မည်မဟုတ်ပါ။
        </p>
      </div>
      <div class="msg">
        <h4>
          ဤအချက်အလက်ကို ကျွန်ုပ်တို့စုဆောင်းရသည့် ရည်ရွယ်ချက်များတွင်-
        </h4>
        <p>
          သင့်အား ချေးငွေဝန်ဆောင်မှုများ ပေးဆောင်ခြင်း- အချက်အလက်စုဆောင်းခြင်း၏
          ရည်ရွယ်ချက်မှာ သင့်အား ပေးဆောင်သည့် အချက်အလက်များအပေါ် အခြေခံ၍
          ချေးငွေဝန်ဆောင်မှုများ ပေးအပ်ရန်နှင့် သက်ဆိုင်ရာ
          ချေးငွေလျှောက်လွှာများနှင့် လုပ်ငန်းဆောင်ရွက်မှုများကို
          လုပ်ဆောင်ရန်ဖြစ်သည်။
          <br />
          အကောင့်စီမံခန့်ခွဲမှုနှင့် ပြုပြင်ထိန်းသိမ်းခြင်း- တိကျမှုနှင့်
          ပြီးပြည့်စုံမှုသေချာစေရန် အပလီကေးရှင်းပေါ်ရှိ သင့်အကောင့်နှင့်
          သုံးစွဲသူပရိုဖိုင်ကို စီမံခန့်ခွဲထိန်းသိမ်းရန် စုဆောင်းထားသော
          အချက်အလက်များကို ကျွန်ုပ်တို့ အသုံးပြုပါသည်။
          <br />
          ဘေးကင်းရေး၊ သမာဓိနှင့် လုံခြုံရေးကို မြှင့်တင်ခြင်း- ကျွန်ုပ်တို့သည်
          အက်ပ်၏ လုံခြုံရေးကို သေချာစေရန် ကျွန်ုပ်တို့စုဆောင်းထားသော
          အချက်အလက်များကို အသုံးပြုပြီး လိမ်လည်မှု၊ အလွဲသုံးမှုနှင့်
          ခွင့်ပြုချက်မရှိဘဲ ဝင်ရောက်ခြင်းမှ ကာကွယ်ရန် လိုအပ်သော ခြေလှမ်းများကို
          လုပ်ဆောင်ပါသည်။
          <br />
          လုပ်ငန်းစီမံခန့်ခွဲမှုရည်ရွယ်ချက်များ- စာရင်းအင်းခွဲခြမ်းစိတ်ဖြာခြင်း၊
          အစီရင်ခံခြင်းနှင့် စာရင်းစစ်ခြင်းကဲ့သို့သော
          ပြည်တွင်းစီးပွားရေးလုပ်ငန်းဆောင်ရွက်မှုများနှင့်
          ဆုံးဖြတ်ချက်ချခြင်းကို ပံ့ပိုးရန်အတွက် စုဆောင်းထားသော
          အချက်အလက်များနှင့် မှတ်တမ်းစီမံခန့်ခွဲမှုအတွက် ကျွန်ုပ်တို့
          အသုံးပြုနိုင်ပါသည်။
          <br />
          သက်ဆိုင်ရာ ကြော်ငြာများနှင့် ကမ်းလှမ်းချက်များကို ပေးဆောင်ပါ- သင်၏
          ကိုယ်ရေးကိုယ်တာ အချက်အလက်နှင့် လိုအပ်ချက်များအရ၊ သင့်အား
          အသက်ဆိုင်ဆုံးသော ကြော်ငြာများနှင့်/သို့မဟုတ် ကမ်းလှမ်းချက်များကို
          ပေးဆောင်ရန်၊ ကျွန်ုပ်တို့သည် သင့်အား စုဆောင်းထားသော အချက်အလက်များကို
          ပိုမိုအသုံးပြု၍ ပုဂ္ဂိုလ်ရေးဆန်သော အတွေ့အကြုံနှင့် ဝန်ဆောင်မှုများကို
          ပေးစွမ်းနိုင်ပါသည်။
        </p>
      </div>
      <div class="msg">
        <h4>
          ကျွန်ုပ်တို့သည် သင်၏ ကိုယ်ရေးကိုယ်တာ အချက်အလက် ကာကွယ်ရေးနှင့်
          ကိုယ်ရေးကိုယ်တာ လုံခြုံမှုကို အလွန်အလေးထားပါသည်။ သင်၏ဒေတာကို
          စုဆောင်းသည့်အခါ၊ ကျွန်ုပ်တို့သည် အောက်ပါအခြေခံမူများကို လိုက်နာပါမည်-
        </h4>
        <p>
          ကန့်သတ်ထားသောရည်ရွယ်ချက်- ကျွန်ုပ်တို့သည် သင့်ဒေတာကို
          တိကျသောရည်ရွယ်ချက်တစ်ခုအတွက်သာ စုဆောင်းမည်ဖြစ်ပြီး
          သင့်ခွင့်ပြုချက်မရှိဘဲ အခြားရည်ရွယ်ချက်တစ်ခုအတွက်
          ၎င်းကိုအသုံးပြုမည်မဟုတ်ပါ၊ အခြားတရားဝင်အခြေခံအချက်များ အကျုံးဝင်သည်
          သို့မဟုတ် မူရင်းရည်ရွယ်ချက်နှင့် ကိုက်ညီမှုမရှိပါက
          ၎င်းကိုအသုံးပြုမည်မဟုတ်ပါ။
          <br />
          Data လုံခြုံရေး- ကျွန်ုပ်တို့သည်
          သင်၏ကိုယ်ရေးကိုယ်တာအချက်အလက်များ၏လုံခြုံရေးကိုကာကွယ်ရန်နှင့်
          ခွင့်ပြုချက်မရှိဘဲဝင်ရောက်ခြင်း၊ အသုံးပြုခြင်း သို့မဟုတ်
          ထုတ်ဖော်ခြင်းတို့ကို တားဆီးရန် လိုအပ်သောနည်းပညာနှင့်
          အဖွဲ့အစည်းဆိုင်ရာအစီအမံများကို လုပ်ဆောင်ပါသည်။
          <br />
          Data Retention- ကျွန်ုပ်တို့သည် စုဆောင်းထားသည့် ရည်ရွယ်ချက်ကို
          ဖြည့်ဆည်းရန် သို့မဟုတ် တည်ဆဲဥပဒေများနှင့် စည်းမျဉ်းများ လိုအပ်ချက်အရ
          လိုအပ်သမျှကာလပတ်လုံး သင့်ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို
          သိမ်းဆည်းထားပါမည်။ သင်၏ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို
          မလိုအပ်တော့သည်နှင့် လုံခြုံစွာဖျက်စီးရန် သို့မဟုတ် အမည်ဝှက်ထားရန်
          ခြေလှမ်းများလုပ်ဆောင်ပါမည်။
          <br />
           ဒေတာမျှဝေခြင်း- ကျွန်ုပ်တို့သည် မည်သည့်အခြေအနေမျိုးတွင်မဆို
          သင့်ကိုယ်ရေးကိုယ်တာဒေတာကို ရောင်းချမည်မဟုတ်ပါ။
          ကျွန်ုပ်တို့၏ဝန်ဆောင်မှုများကို ပေးဆောင်ရန်မလိုအပ်ပါက အပိုဒေတာကို
          သင့်အား တောင်းဆိုမည်မဟုတ်ပါ။ ဒေတာဝင်ရောက်ခွင့်နှင့် ဖျက်ခြင်း-
          အချက်အလက်အချို့ကို ပေးဆောင်ရန် သင့်အား တောင်းဆိုခြင်းမရှိပါက
          အပလီကေးရှင်းတွင် မည်သည့်အချက်အလက်ကို မျှဝေရန် သင့်တွင်
          ဆုံးဖြတ်ပိုင်ခွင့်ရှိသည်။ အပလီကေးရှင်း သို့မဟုတ် မိုဘိုင်းစက်ပစ္စည်း၏
          ဆက်တင်များမှတစ်ဆင့် သင့်စိတ်ကြိုက်ရွေးချယ်မှုများကို
          စီမံခန့်ခွဲနိုင်သည်။ အကယ်၍ သင်သည် အပလီကေးရှင်းကို မသုံးချင်တော့ပါက၊
          ၎င်းကို သင်၏ မိုဘိုင်းစက်ပစ္စည်းမှ အချိန်မရွေး လုံးဝ
          ဖျက်ပစ်နိုင်ပါသည်။ ၎င်းက အက်ပ်နှင့်ဆက်စပ်နေသည့် ဒေတာနှင့်
          ဆက်တင်အားလုံးကို ဖျက်လိုက်ပါမည်။ ကျွန်ုပ်တို့သည် သင့်အား
          ဝန်ဆောင်မှုပေးနိုင်ရန်အတွက် အချို့သောအချက်အလက်များ
          လိုအပ်နိုင်သည့်အတွက်ကြောင့် ဆက်တင်များကို ပြောင်းလဲခြင်း သို့မဟုတ်
          အက်ပ်ကို ဖျက်ခြင်းဖြင့် ရှောင်လွှဲ၍မရနိုင်ကြောင်း ကျေးဇူးပြု၍
          သတိပြုပါ။ ဒေတာအားလုံးကို ဖျက်ရန် လိုအပ်ပါက အောက်ပါအီးမေးလ်လိပ်စာ-
          cauliflowermrcheng@gmail.com သို့ ဆက်သွယ်နိုင်ပါသည်။ ပံ့ပိုးကူညီမှုတွေ
          ပေးနိုင်ဖို့ အစွမ်းကုန် ကြိုးစားသွားမှာပါ။
        </p>
      </div>
      <div class="msg">
        <h4>
          သင်၏ ကိုယ်ရေးကိုယ်တာ အချက်အလက်များကို သိမ်းဆည်းခြင်းနှင့်
          ကာကွယ်ခြင်းသည် ကျွန်ုပ်တို့အတွက် အလွန်အရေးကြီးပါသည်-
        </h4>
        <p>
           သိုလှောင်မှုနှင့် ကာကွယ်မှု- ကာကွယ်ရန်အတွက် ကျွန်ုပ်တို့သည်
          စုဆောင်းထားသော ကိုယ်ရေးကိုယ်တာအချက်အလက်များကို လုံခြုံရေးစင်တာ
          (https://runa.runaway1quickget.com/) သို့ အပ်လုဒ်လုပ်ပါသည်။
          သင်၏ကိုယ်ရေးကိုယ်တာနှင့် လုံခြုံရေးကို ထိန်းသိမ်းထားကြောင်း သေချာစေရန်
          သင့်အကောင့်ကို စကားဝှက်ဖြင့် ကာကွယ်ထားသည်။ <br />
          Data ထိန်းသိမ်းမှုမူဝါဒ- ကျွန်ုပ်တို့သည် ဒေတာထိန်းသိမ်းမှုမူဝါဒကို
          လိုက်နာပြီး လိုက်နာမှုရှိသော ထိန်းသိမ်းမှုကာလကုန်ဆုံးပြီးနောက်
          သင့်အချက်အလက်များကို ဘေးကင်းစွာ စီမံဆောင်ရွက်ပေးပါမည်။
          သင်၏အခွင့်အရေးများကို လေးစားလိုက်နာရန်အတွက်
          ကိုယ်ရေးကိုယ်တာပြဿနာများနှင့်ပတ်သက်သည့် စုံစမ်းမေးမြန်းမှုများကို
          ဆောလျင်စွာနှင့် ပွင့်လင်းမြင်သာစွာ ကိုင်တွယ်ဆောင်ရွက်ကြောင်း
          သေချာပါသည်။<br />
          Employee Training- ကျွန်ုပ်တို့၏ဝန်ထမ်းများသည် သက်ဆိုင်ရာ
          မူဝါဒများနှင့် အစီအမံများကို နားလည်ပြီး လိုက်နာကြောင်း သေချာစေရန်အတွက်
          ကျွန်ုပ်တို့၏ဝန်ထမ်းများသည် ကိုယ်ရေးကိုယ်တာနှင့် လုံခြုံရေးဆိုင်ရာ
          တာဝန်ဝတ္တရားများဆိုင်ရာ သင်တန်းများကို လက်ခံရရှိပါသည်။<br />
           နည်းပညာပိုင်းဆိုင်ရာနှင့် အဖွဲ့အစည်းဆိုင်ရာ အစီအမံများ- သင့်ဒေတာကို
          သိမ်းဆည်းသည့်နေရာတိုင်းတွင် ကာကွယ်ရန် သင့်လျော်သော နည်းပညာနှင့်
          အဖွဲ့အစည်းဆိုင်ရာ အစီအမံများကို ကျွန်ုပ်တို့ လုပ်ဆောင်ပါသည်။
          ဒေတာပရိုဆက်ဆာများအားလုံးသည်
          ကျွန်ုပ်တို့၏လုံခြုံရေးလိုအပ်ချက်များနှင့်ကိုက်ညီကြောင်း
          သေချာစေရန်နှင့် ကျွန်ုပ်တို့၏ကတိကဝတ်များကို
          စာချုပ်ပါအပိုဒ်များမှတစ်ဆင့် လေးစားလိုက်နာရန် လိုအပ်ပါသည်။<br />
           အလိုအလျောက် ဆုံးဖြတ်ချက်ချခြင်း- သင့်အခွင့်အရေးများကို
          ဆိုးရွားစွာထိခိုက်စေနိုင်သော အလိုအလျောက်ဆုံးဖြတ်ချက်များချရန်အတွက်
          ကျွန်ုပ်တို့သည် သင့်ဒေတာကို အသုံးပြုမည်မဟုတ်ပါ။
        </p>
      </div>
      <div class="msg">
        <h4>
          ဤကိုယ်ရေးကိုယ်တာမူဝါဒကို အပြောင်းအလဲများ-
        </h4>
        <p>
          ကျွန်ုပ်တို့၏တစ်ဦးတည်းဆုံးဖြတ်ချက်ဖြင့် ဤကိုယ်ရေးကိုယ်တာမူဝါဒကို
          အချိန်မရွေးပြောင်းလဲပိုင်ခွင့်ကို ကျွန်ုပ်တို့လက်ဝယ်ရှိပါသည်။
          ကျွန်ုပ်တို့၏ ဝဘ်ဆိုက်ရှိ လင့်ခ်မှတစ်ဆင့် လတ်တလော ကိုယ်ရေးကိုယ်တာ
          မူဝါဒ အပ်ဒိတ်ကို အချိန်မရွေး ပြန်လည်ကြည့်ရှုနိုင်ပါသည်။
          ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်တွင် ပြန်လည်ပြင်ဆင်ထားသော ကိုယ်ရေးကိုယ်တာမူဝါဒ၏
          အီလက်ထရွန်နစ်ဆက်သွယ်ရေးနှင့်/သို့မဟုတ် ပို့စ်တင်ခြင်းကို လက်ခံရရှိရန်
          သင်သဘောတူပြီး ထိုကဲ့သို့သော အီလက်ထရွန်နစ်ဆက်သွယ်ရေး သို့မဟုတ်
          ပို့စ်တင်ခြင်းများသည် သင့်အတွက် လျှို့ဝှက်ရေးမူဝါဒ၏
          သတိပေးချက်ဖြစ်ကြောင်း သင်သဘောတူပါသည်။
          <br />
          တာဝန်ယူမှုထုတ်ပြန်ချက်-
          ပရော်ဖက်ရှင်နယ်ငွေကြေးထုတ်ကုန်ပလပ်ဖောင်းတစ်ခုအနေဖြင့်
          အင်္ဂလိပ်လိုင်းသည် သုံးစွဲသူများအတွက် ဘေးကင်းလုံခြုံ၍
          ယုံကြည်စိတ်ချရသော၊ အသုံးပြုသူဗဟိုပြုငွေကြေးဆိုင်ရာထုတ်ကုန်များကို
          စတင်ထုတ်လုပ်ရန် ကတိပြုပါသည်။
          ကျွန်ုပ်တို့၏ပလက်ဖောင်း၏တာဝန်ကိုကျွန်ုပ်တို့သန္နိဋ္ဌာန်ချထားစဉ်တွင်၊
          အင်္ဂလိပ်လိုင်းသည်
          <br />
          တိုက်ရိုက်ငွေချေးခြင်းလုပ်ငန်းများတွင်ပါဝင်ခြင်းမရှိကြောင်းသတိပြုရန်အရေးကြီးပါသည်။
          တစ်ဦးချင်း၏ ခရက်ဒစ်၊ ဝင်ငွေနှင့် ပထဝီဝင်တည်နေရာအပေါ် အခြေခံ၍
          ခရက်ဒစ်ခွင့်ပြုချက်နှင့် စည်းကမ်းချက်များကို ဘဏ္ဍာရေးအဖွဲ့အစည်းက
          ဆုံးဖြတ်သည်။ ၎င်းသည် ကမ်းလှမ်းထားသော ထုတ်ကုန်များတွင် ပြောင်းလဲမှုများ
          ဖြစ်ပေါ်နိုင်သည်။ ကူညီဆောင်ရွက်ပေးသူတစ်ဦးအနေဖြင့်၊ ကျွန်ုပ်တို့သည်
          သုံးစွဲသူများအား တတ်နိုင်သော ငွေကြေးဆိုင်ရာ ရွေးချယ်စရာများကို
          ပေးဆောင်ရန် ရည်ရွယ်ပါသည်။ ၎င်းသည် အသိပေးပြီး အကျိုးရှိသော
          ဘဏ္ဍာရေးဆိုင်ရာ ဆုံးဖြတ်ချက်များချရာတွင် ကူညီပေးသည်။
          <br />
          ကျွန်ုပ်တို့သည် ဤကိုယ်ရေးကိုယ်တာမူဝါဒကို အပြောင်းအလဲများပြုလုပ်ပါက၊
          ပြန်လည်ပြင်ဆင်ထားသော ကိုယ်ရေးကိုယ်တာမူဝါဒကို ပို့စ်တင်ခြင်း၊
          ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်ပေါ်တွင် သတိပေးချက်တစ်ခုတင်ခြင်း၊ သို့မဟုတ်
          အက်ပလီကေးရှင်းအတွင်း ပေါ့ပ်အပ်ဝင်းဒိုးမှတစ်ဆင့် သို့မဟုတ် ဥပဒေအရ
          လိုအပ်ချက်အရ အကြောင်းကြားပါမည်။ ပြုပြင်မွမ်းမံမှုများအတွက်
          ကိုယ်ရေးကိုယ်တာမူဝါဒကို အချိန်အခါအလိုက် ပြန်လည်သုံးသပ်ရန် သင်သည်
          သဘောတူပါသည်။ ပြန်လည်ပြင်ဆင်ထားသော ကိုယ်ရေးကိုယ်တာမူဝါဒကို
          ကျွန်ုပ်တို့တင်ပြီးနောက် သို့မဟုတ် ကျွန်ုပ်တို့၏ဝဘ်ဆိုက်တွင်
          သတိပေးချက်တစ်ခုပေးပြီးနောက် ဝန်ဆောင်မှုများကို
          ဆက်လက်အသုံးပြုနေခြင်းသည် ပြန်လည်ပြင်ဆင်ထားသော ကိုယ်ရေးကိုယ်တာမူဝါဒကို
          သင်လက်ခံကြောင်း သဘောတူပါသည်။
        </p>
      </div>
      <div class="msg">
        <h4>
          ကြှနျုပျတို့ကိုဆကျသှယျရနျ:
        </h4>
        <p>
          သင့်ကိုယ်ရေးကိုယ်တာအချက်အလက်များ၏ လုံခြုံရေးနှင့်
          ကာကွယ်မှုသေချာစေရန်နှင့် ကျွန်ုပ်တို့၏ကတိကဝတ်များကို လေးစားလိုက်နာရန်
          ကျွန်ုပ်တို့ ဆက်လက်ကြိုးစားသွားပါမည်။ သင့်တွင်
          ကိုယ်ရေးကိုယ်တာအချက်အလက်များ သိုလှောင်မှုနှင့် ကာကွယ်မှုဆိုင်ရာ
          မေးခွန်းများရှိပါက၊ အောက်ပါအီးမေးလ်လိပ်စာ-
          cauliflowermrcheng@gmail.com သို့ ဆက်သွယ်နိုင်ပါသည်။
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: "",
  },
  data() {
    return {
      showPrivasi: false,
    };
  },
  created() {
    console.log(this.showPrivasi);
    if (this.show == true) {
      this.showPrivasi = true;
    }
  },
};
</script>
<style lang="less">
@import url("@/style/m_index.less") only screen and (max-width: 750px);
@import url("@/style/pc_index.less") only screen and (min-width: 750px);
</style>
